import React, { useEffect } from 'react';
import Footer from './Footer';
import { useScripts } from '../hooks/useScripts';

function TutorialLayout({ title, description, children }) {
  useScripts();
  
  useEffect(() => {
    // Add login-form class to body for proper styling
    document.body.classList.add('login-form');
    
    // Cleanup: remove class when component unmounts
    return () => {
      document.body.classList.remove('login-form');
    };
  }, []);
  
  return (
    <>
      <div className="container single-blog" style={{ marginTop: '40px' }}>
        <div className="post">
          <div className="top-post">
            <h3><a rel="title">{title}</a></h3>
          </div>
          
          <div className="description">
            <p>{description}</p>
          </div>
          
          <div className="content-post">
            {children}
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
}

export default TutorialLayout;
